import React from 'react'
import { Route } from 'react-router-dom'
import asyncComponent from 'lib/react/async_component'

const SignUp = asyncComponent(() => import('./passport/sign-up').then(module => module.default))
const Login =  asyncComponent(() => import('./passport/login').then(module => module.default))
const My =  asyncComponent(() => import('./my').then(module => module.default))
const NotFound =  asyncComponent(() => import('./public/404').then(module => module.default))

export default class Global extends React.Component {
  // 路由配置
  static routes = [
    {path: '/login', exact: true, component: Login},
    {path: '/signup', exact: true, component: SignUp},
    {path: '/my', exact: true, component: My},
  ]
  
  render() {
    return (
      <div>
        {this.constructor.routes.map((route, index) =>
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={route.component}
          />
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/global/index.js